"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotDetailsTab = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var functions_1 = require("../../../constants/functions");
var extra_data_1 = require("../../../controls/extra_data/extra_data");
var doshx_controls_web_1 = require("doshx_controls_web");
var main_1 = require("../../../reducers/slices/main");
var moment_1 = __importDefault(require("moment"));
var get_lot_1 = require("../../../api/calls/lot/v3/get_lot");
var create_lot_1 = require("../../../api/calls/lot/v3/create_lot");
var update_lot_1 = require("../../../api/calls/lot/v3/update_lot");
var textarea_1 = require("../../../controls/textarea/textarea");
var upload_1 = require("../../../api/calls/file/upload");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var delete_1 = require("../../../api/calls/file/delete");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_toastify_1 = require("react-toastify");
var heic2any_1 = __importDefault(require("heic2any"));
var LotDetailsTab = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var lot_id = props.lot_id, onSave = props.onSave;
    var lotTypes = ["Collectables", "Collector Cars", "Livestock", "Machinery", "Real Estate", "Vehicles/Trucks"];
    var lotStatuses = ["Bidding Closed", "Bidding Open", "Sold", "Passed", "Withdrawn"];
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _z = (0, react_1.useState)(false), isSaving = _z[0], setIsSaving = _z[1];
    // const { lots, selectedLot, isEditing } = useSelector<any, any>((state) => state.lotState);
    var _0 = (0, react_1.useState)({
        title: "",
        broker_name: "",
        other_info: "lot_broker_image",
        broker_image: "",
        description: "",
        starting_price: "",
        reserve_price: "",
        vendor_bidding: {
            enabled: false,
            bid_increment: "",
            bid_limit: "",
            timeout: 0,
        },
        contacts: {
            email: "",
            phone: {
                country_code: "ZA",
                calling_code: "+27",
                number: "",
            },
            whatsapp: {
                country_code: "ZA",
                calling_code: "+27",
                number: "",
            },
        },
        location: null,
        status: "Bidding Closed",
        extra_data: [],
        youtube_url: "",
    }), lot = _0[0], setLot = _0[1];
    var mainAuction = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).mainAuction;
    var selectedClient = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).selectedClient;
    (0, react_1.useEffect)(function () {
        if (lot) {
            loadExtraData();
        }
    }, [lot]);
    (0, react_1.useEffect)(function () {
        if (lot_id) {
            // Editing
            (0, get_lot_1.get_lot)({
                entity_id: lot_id,
            }).then(function (response) {
                var _a, _b;
                if (response.data.success) {
                    var lotData = response.data.content;
                    console.log("lotData", lotData);
                    if (!(lotData === null || lotData === void 0 ? void 0 : lotData.contacts)) {
                        lotData.contacts = {};
                    }
                    if (!((_a = lotData === null || lotData === void 0 ? void 0 : lotData.contacts.phone) === null || _a === void 0 ? void 0 : _a.number)) {
                        lotData.contacts.phone = {
                            country_code: "ZA",
                            calling_code: "+27",
                            number: "",
                        };
                    }
                    if (!((_b = lotData === null || lotData === void 0 ? void 0 : lotData.contacts.whatsapp) === null || _b === void 0 ? void 0 : _b.number)) {
                        lotData.contacts.whatsapp = {
                            country_code: "ZA",
                            calling_code: "+27",
                            number: "",
                        };
                    }
                    setLot(lotData);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.data.message] }));
                }
            });
        }
        else {
            // Creating
            setLot(__assign(__assign({}, lot), { status: "Bidding Closed" }));
        }
    }, [lot_id]);
    var _1 = (0, react_1.useState)([]), extraData = _1[0], setExtraData = _1[1];
    var fieldChanged = function (name, value) {
        var _a;
        setLot(__assign(__assign({}, lot), (_a = {}, _a[name] = value, _a)));
    };
    var loadExtraData = function () {
        if (lot.extra_data) {
            var ed = [];
            for (var _i = 0, _a = lot.extra_data; _i < _a.length; _i++) {
                var d = _a[_i];
                ed.push({ key: d.key, value: d.value });
            }
            setExtraData(ed);
        }
    };
    var validate = function () {
        var messages = [];
        // if (fields.is_popular) {
        //   messages.push("Is Popular is required.");
        // }
        if (lot.title.length == 0) {
            messages.push("Title is required.");
        }
        if (lot.description.length == 0) {
            messages.push("Description is required.");
        }
        // if (fields.starting_price.length == 0) {
        //   messages.push("Starting price is required.");
        // }
        if (lot.status == null) {
            messages.push("Status is required.");
        }
        if (lot.vendor_bidding && lot.vendor_bidding.enabled) {
            var _a = lot.vendor_bidding, bid_increment = _a.bid_increment, bid_limit = _a.bid_limit, timeout = _a.timeout;
            if (!bid_increment) {
                messages.push("Bid Increment is required.");
            }
            else {
                if (parseFloat(bid_increment) <= 0) {
                    messages.push("Bid Increment must be greater than 0.");
                }
            }
            if (!bid_limit) {
                messages.push("Bid Limit is required.");
            }
            else {
                if (parseFloat(bid_limit) <= 0) {
                    messages.push("Bid Limit must be greater than 0.");
                }
            }
            // moment from minutes to seconds
            if (moment_1.default.duration(timeout, "seconds").asMinutes() < 1) {
                messages.push("Timeout must be at least 1 minute.");
            }
            // bid amount must be < bid limit
            if (parseFloat(bid_increment) > parseFloat(bid_limit)) {
                messages.push("The Bid Increment must be less than or equal to the Bid Limit.");
            }
        }
        // if (fields.type == null) {
        //   messages.push("Type is required.");
        // }
        if (extraData.length > 0) {
            //Check that all extra data have been assigned.
            for (var _i = 0, extraData_1 = extraData; _i < extraData_1.length; _i++) {
                var ed = extraData_1[_i];
                var index = extraData.indexOf(ed);
                if (!ed.key || !ed.value) {
                    messages.push("You did not fill in all fields for the ".concat((0, functions_1.toOrdinalSuffix)(index + 1), " data entry."));
                }
            }
        }
        if (messages && messages.length > 0) {
            dispatch((0, main_1.setMessageModal)({ title: "Validation failed!", messages: messages }));
            return false;
        }
        else {
            return true;
        }
    };
    var _2 = (0, react_1.useState)(null), brokerImage = _2[0], setBrokerImage = _2[1];
    var _3 = (0, react_1.useState)(null), image = _3[0], setImage = _3[1];
    var fileInputRef = (0, react_1.useRef)(null);
    var _4 = (0, react_1.useState)([]), files = _4[0], setFiles = _4[1];
    // Load existing image when component mounts or lot data changes
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if ((_b = (_a = lot === null || lot === void 0 ? void 0 : lot.broker_images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.uploaded_file_url) {
            setImage(lot.broker_images[0].uploaded_file_url);
        }
    }, [lot]);
    // const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //   const file = e.target.files?.[0];
    //   if (file) {
    //     setBrokerImage(file);
    //     setImage(URL.createObjectURL(file));
    //   }
    // };
    var handleImageChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var file, processedFile, convertedBlob, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (!file) return [3 /*break*/, 5];
                    processedFile = file;
                    if (!(file.name.toLowerCase().endsWith('.heic') || file.type === 'image/heic')) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, heic2any_1.default)({
                            blob: file,
                            toType: 'image/jpeg',
                            quality: 0.8
                        })];
                case 2:
                    convertedBlob = _b.sent();
                    processedFile = new File([convertedBlob], file.name.replace(/\.heic$/i, '.jpg'), {
                        type: 'image/jpeg',
                        lastModified: file.lastModified
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    console.error('HEIC conversion failed:', err_1);
                    return [3 /*break*/, 4];
                case 4:
                    setBrokerImage(processedFile);
                    setImage(URL.createObjectURL(processedFile));
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveImage = function (e) {
        e.stopPropagation();
        setBrokerImage(null);
        setImage(null);
        if (fileInputRef.current)
            fileInputRef.current.value = "";
    };
    var deleteFile = function (file_id) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!file_id)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, delete_1.delete_file)({ file_entity_id: file_id })];
                case 2:
                    response = _a.sent();
                    if (response.data.success) {
                        setImage(null);
                        setBrokerImage(null);
                        if (fileInputRef.current)
                            fileInputRef.current.value = "";
                        react_toastify_1.toast.success("Image deleted successfully");
                    }
                    else {
                        react_toastify_1.toast.error(response.data.message || "Failed to delete image");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error deleting image:", error_1);
                    react_toastify_1.toast.error("Error deleting image");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "flex flex-col w-full" }, lot ? (react_1.default.createElement("div", { className: "flex flex-col space-y-4 p-4 w-full" },
        react_1.default.createElement("div", { className: "flex flex-row gap-4 justify-start" }, lot.entity_id ? (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Update Details", 
            // theme="blue"
            size: "small", loading: isSaving, backgroundColor: "bg-green-500", onClick: function () {
                if (validate()) {
                    var request = {
                        // ...lot,
                        title: lot.title,
                        broker_name: lot.broker_name,
                        // other_info: "lot broker image",
                        description: lot.description,
                        starting_price: lot.starting_price,
                        reserve_price: lot.reserve_price,
                        vendor_bidding: lot.vendor_bidding,
                        status: lot.status,
                        extra_data: extraData,
                        youtube_url: lot.youtube_url,
                        location: lot.location,
                        contacts: lot === null || lot === void 0 ? void 0 : lot.contacts,
                    };
                    setIsSaving(true);
                    (0, update_lot_1.update_lot)({
                        entity_id: lot.entity_id,
                        entity: request,
                    }).then(function (response) {
                        var _a, _b;
                        setIsSaving(false);
                        var lot_entity_id = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.entity_id;
                        console.log(lot_entity_id, "Created Lot");
                        if (response.data.success) {
                            if (brokerImage) {
                                (0, upload_1.upload_file)({
                                    lot_id: lot_entity_id,
                                    type: "Image",
                                    file: brokerImage,
                                    other_info: "lot_broker_image",
                                });
                            }
                            // navigate("/console/lots");
                            dispatch((0, main_1.setMessageModal)({
                                title: "Success!",
                                messages: [lot_id ? "Lot updated successfully." : "Lot created successfully."],
                            }));
                            onSave(response.data.content);
                        }
                        else {
                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.data.message] }));
                        }
                    });
                }
            } })) : (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Create Lot", 
            // theme="blue"
            size: "small", loading: isSaving, backgroundColor: "bg-green-500", onClick: function () {
                if (validate()) {
                    var request = {
                        // ...lot,
                        title: lot.title,
                        broker_name: lot.broker_name,
                        // other_info: "lot broker image",
                        description: lot.description,
                        starting_price: lot.starting_price,
                        reserve_price: lot.reserve_price,
                        vendor_bidding: lot.vendor_bidding,
                        auction_entity_id: mainAuction.entity_id,
                        status: lot.status,
                        extra_data: extraData,
                        youtube_url: lot.youtube_url,
                        location: lot.location,
                        contacts: lot === null || lot === void 0 ? void 0 : lot.contacts,
                        // _id: lot_id,
                    };
                    setIsSaving(true);
                    (0, create_lot_1.create_lot)(request).then(function (response) {
                        var _a, _b;
                        setIsSaving(false);
                        var lot_entity_id = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.entity_id;
                        console.log(lot_entity_id, "Created Lot");
                        if (response.data.success) {
                            // Upload broker image if it exists
                            if (brokerImage) {
                                (0, upload_1.upload_file)({
                                    lot_id: lot_entity_id,
                                    type: "Image",
                                    file: brokerImage,
                                    other_info: "lot_broker_image",
                                });
                            }
                            // navigate("/console/lots");
                            dispatch((0, main_1.setMessageModal)({
                                title: "Success!",
                                messages: [lot_id ? "Lot updated successfully." : "Lot created successfully."],
                            }));
                            onSave(response.data.content);
                        }
                        else {
                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.data.message] }));
                        }
                    });
                }
            } }))),
        react_1.default.createElement("div", { className: "w-full" },
            react_1.default.createElement("div", { className: "w-1/3 mb-4" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Broker Image", value: "Please Upload Broker Image", disabled: true, onChange: function (v) { return fieldChanged("title", v); } })),
            react_1.default.createElement("div", { className: "mb-4" },
                react_1.default.createElement("div", { className: "border-4 border-dashed ".concat(image ? "border-green-500" : "border-black", " text-black text-2xl w-full rounded-xl p-4 cursor-pointer text-center hover:underline relative"), onClick: function () { var _a; return !image && ((_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click()); } },
                    image ? (react_1.default.createElement("div", { className: "w-full" },
                        " ",
                        react_1.default.createElement("div", { className: "size-[160px] relative" },
                            react_1.default.createElement("img", { src: image, alt: "Broker preview", className: "object-cover w-full h-full mb-2" }),
                            !brokerImage && ((_b = (_a = lot === null || lot === void 0 ? void 0 : lot.broker_images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.entity_id) && (react_1.default.createElement("div", { className: "w-8 h-8 rounded-full bg-red-500 text-white text-sm absolute \n                                    top-0 right-0 flex justify-center items-center cursor-pointer\n                                     shadow-[0_0px_10px_0px_rgba(0,0,0,0.3)] z-10", onClick: function (e) {
                                    e.stopPropagation();
                                    deleteFile(lot.broker_images[0].entity_id);
                                } },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTimes }))),
                            brokerImage && (react_1.default.createElement("div", { className: "w-8 h-8 rounded-full bg-red-500 text-white text-sm absolute \n                                  top-0 right-0 flex justify-center items-center cursor-pointer\n                                   shadow-[0_0px_10px_0px_rgba(0,0,0,0.3)] z-10", onClick: handleRemoveImage },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTimes })))))) : (react_1.default.createElement("span", null, "Please Upload Broker Image")),
                    react_1.default.createElement("input", { type: "file", accept: "image/*", ref: fileInputRef, onChange: handleImageChange, className: "hidden", multiple: false })))),
        react_1.default.createElement("div", { className: "flex" }, ((_c = mainAuction === null || mainAuction === void 0 ? void 0 : mainAuction.automated) === null || _c === void 0 ? void 0 : _c.enabled) && (react_1.default.createElement("div", { className: "p-4 border-2 border-blue-500 rounded-lg" },
            react_1.default.createElement("div", { className: "flex gap-4" },
                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Enable Vendor Bidding?", value: (_d = lot.vendor_bidding) === null || _d === void 0 ? void 0 : _d.enabled, onChange: function (v) {
                        setLot(__assign(__assign({}, lot), { vendor_bidding: __assign(__assign({}, lot.vendor_bidding), { enabled: v }) }));
                    } }),
                ((_e = lot.vendor_bidding) === null || _e === void 0 ? void 0 : _e.enabled) && (react_1.default.createElement("div", { className: "flex gap-4" },
                    react_1.default.createElement("div", { className: "w-48" }, ((_f = selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.bid_increments) === null || _f === void 0 ? void 0 : _f.length) > 0 ? (react_1.default.createElement(doshx_controls_web_1.NewDropdownControl, { label: "Bid Increment", value: (_g = lot.vendor_bidding) === null || _g === void 0 ? void 0 : _g.bid_increment, renderDisplay: function (x) {
                            // Utilities.formatMoney({
                            //   value: x.toString(),
                            //   decimalPlaces: 2,
                            // })
                            return x;
                        }, size: "small", options: selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.bid_increments, onChange: function (v) {
                            setLot(__assign(__assign({}, lot), { vendor_bidding: __assign(__assign({}, lot.vendor_bidding), { bid_increment: v }) }));
                        }, colors: {
                            borderColor: "border-black",
                            labelColor: "text-black",
                        } })) : (react_1.default.createElement("div", { className: "text-xs text-red-500" }, "Before you can enable Vendor Bidding, you need to set the Bid Increments for this client. Go to the Client's page to set the Bid Increments."))),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Bid Limit", type: "number", size: "small", value: (_h = lot.vendor_bidding) === null || _h === void 0 ? void 0 : _h.bid_limit, onChange: function (v) {
                            setLot(__assign(__assign({}, lot), { vendor_bidding: __assign(__assign({}, lot.vendor_bidding), { bid_limit: v }) }));
                        } }),
                    react_1.default.createElement("div", { className: "w-28" },
                        react_1.default.createElement(doshx_controls_web_1.TimeoutSelectorControl, { label: "Timeout", views: ["minutes"], value: moment_1.default.duration((_j = lot.vendor_bidding) === null || _j === void 0 ? void 0 : _j.timeout, "seconds").asMilliseconds(), size: "small", onChange: function (v) {
                                setLot(__assign(__assign({}, lot), { vendor_bidding: __assign(__assign({}, lot.vendor_bidding), { 
                                        // ms to seconds
                                        timeout: moment_1.default.duration(v).asSeconds() }) }));
                            } })))))))),
        react_1.default.createElement("div", { className: "flex gap-4" },
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "flex gap-4" },
                    react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Title", value: lot.title, onChange: function (v) { return fieldChanged("title", v); } }),
                        react_1.default.createElement(textarea_1.TextAreaControl, { label: "Description", lines: 8, value: lot.description, onChange: function (v) { return fieldChanged("description", v); } })),
                    react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Starting Price", type: "number", value: lot.starting_price, onChange: function (v) { return fieldChanged("starting_price", v); } }),
                        react_1.default.createElement(doshx_controls_web_1.NewDropdownControl, { label: "Status", value: lot.status, renderDisplay: function (v) { return v; }, options: lotStatuses, onChange: function (v) {
                                console.log(v);
                                fieldChanged("status", v);
                            }, colors: {
                                labelColor: "text-black",
                                borderColor: "border-black",
                            } }),
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Lot Youtube URL", value: lot.youtube_url, onChange: function (v) { return fieldChanged("youtube_url", v); } }))),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.AddressSearchControl, { label: "Location (Search Address)", placeholder: "Search for an address", value: {
                            fullAddress: (_k = lot === null || lot === void 0 ? void 0 : lot.location) === null || _k === void 0 ? void 0 : _k.full_address,
                            coordinates: {
                                lat: (_l = lot === null || lot === void 0 ? void 0 : lot.location) === null || _l === void 0 ? void 0 : _l.latitude,
                                lng: (_m = lot === null || lot === void 0 ? void 0 : lot.location) === null || _m === void 0 ? void 0 : _m.longitude,
                            },
                        }, onSelectionChange: function (address) {
                            console.log("address", address);
                            fieldChanged("location", {
                                full_address: address.fullAddress,
                                latitude: address.coordinates.lat,
                                longitude: address.coordinates.lng,
                            });
                        }, labelColor: "text-black", textColor: "text-black" }))),
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Phone number", value: (_q = (_p = (_o = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _o === void 0 ? void 0 : _o.phone) === null || _p === void 0 ? void 0 : _p.number) !== null && _q !== void 0 ? _q : "", defaultCountryCode: "ZA", countryCodeValue: (_s = (_r = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _r === void 0 ? void 0 : _r.phone) === null || _s === void 0 ? void 0 : _s.country_code, size: "medium", onChange: function (v) {
                        var _a;
                        setLot(__assign(__assign({}, lot), { contacts: __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { phone: __assign(__assign({}, (_a = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _a === void 0 ? void 0 : _a.phone), { number: v }) }) }));
                    }, onExtensionChange: function (ext, cc) {
                        var _a;
                        var qwe = __assign(__assign({}, lot), { contacts: __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { phone: __assign(__assign({}, (_a = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _a === void 0 ? void 0 : _a.phone), { country_code: cc, calling_code: ext }) }) });
                        console.log("onExtensionChange", qwe);
                        setLot(qwe);
                    } }),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email address", value: (_t = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _t === void 0 ? void 0 : _t.email, type: "text", onChange: function (v) { return fieldChanged("contacts", __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { email: v })); } }),
                react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Whatsapp number", value: (_w = (_v = (_u = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _u === void 0 ? void 0 : _u.whatsapp) === null || _v === void 0 ? void 0 : _v.number) !== null && _w !== void 0 ? _w : "", defaultCountryCode: "ZA", countryCodeValue: (_y = (_x = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _x === void 0 ? void 0 : _x.whatsapp) === null || _y === void 0 ? void 0 : _y.country_code, size: "medium", onChange: function (v) {
                        var _a;
                        setLot(__assign(__assign({}, lot), { contacts: __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { whatsapp: __assign(__assign({}, (_a = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _a === void 0 ? void 0 : _a.whatsapp), { number: v }) }) }));
                    }, onExtensionChange: function (ext, cc) {
                        var _a;
                        setLot(__assign(__assign({}, lot), { contacts: __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { whatsapp: __assign(__assign({}, (_a = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _a === void 0 ? void 0 : _a.whatsapp), { country_code: cc, calling_code: ext }) }) }));
                    } })),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Broker Name", value: lot.broker_name, onChange: function (v) { return fieldChanged("broker_name", v); } }),
            react_1.default.createElement(extra_data_1.ExtraDataControl, { title: "Extra Data", extra_data: extraData, 
                // isLoading={isImagesLoading}
                onChange: function (ed) {
                    console.log("ed", ed);
                    setExtraData(__spreadArray([], ed, true));
                } })))) : (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large" })))));
};
exports.LotDetailsTab = LotDetailsTab;
